import { render, staticRenderFns } from "./SentimentHighUplimit.vue?vue&type=template&id=3536ce42&scoped=true"
import script from "./SentimentHighUplimit.vue?vue&type=script&lang=js"
export * from "./SentimentHighUplimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536ce42",
  null
  
)

export default component.exports